import React from 'react';
import styled from 'styled-components';

import { TableHead, TableRow, ThItem } from '@/component-style/Table';

const THead = styled(TableHead)`
  min-width: 840px;
`;

const Th120 = styled(ThItem)`
  width: 120px;
`;

const Th160 = styled(ThItem)`
  width: 160px;
`;

const Header = props => {
  
  return (
    <THead>
      <TableRow>
        <Th160>帳號</Th160>
        <Th160>同仁名稱</Th160>
        <Th120>所屬公司</Th120>
        <Th120>部門</Th120>
        <Th160>所屬總監</Th160>
        <Th120>狀態</Th120>
        <Th120></Th120>
      </TableRow>
    </THead>
  );
};

export default Header;
